import React, { useEffect, useState } from 'react'
import { ScrollView, Text, View } from 'react-native'
import HeaderWithBack from '../../components/Header/headerWithBack';
import { useTranslation } from 'react-i18next';
import { ImageComp } from '../../components/Image/Image';
import { dateFormatHandler, makeStringStrictlyCapitalize } from '../../js/utility';
import { getCleanUrl, toBool } from '../../utils/Helper';
import { useCssStyle } from '../../customHook/getCssStyle';
import { useDispatch, useSelector } from 'react-redux';
import CustomCheckBoxWithProps from '../../components/checkBox/customCheckBox';
import { formatDate } from '../../js/formatDate';
import DatePickerModal from '../../components/datePickerModal/datePickerModal';
import CustomDropDown from '../../components/customDropdown/customDropdown';
import CustomPressable from '../../components/customPressable/customPressable';
import { CustomTextInput } from '../../components/customTextInput';
import moment from 'moment';
import { HEART } from '../../assets';
import { setRenderFlashMessage } from '../../Redux/Actions/appConfigAction';

const SpaBooking2a = (props) => {
  const { currentWidget, bookingObj, updateBookingObj, handleNext, handleGoBack, updateFetchApiError } = props;
  
  const { t } = useTranslation();
  const getStyles = useCssStyle();
  const dispatch = useDispatch();

  const { currentGuestDetails } = useSelector(
    state => state.guestDetailsSlice,
  );
  
  const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
  const currencyCode = currencyDetails.code;

  const { extraConfigParam } = useSelector(state => state.deviceConfigSlice);
  const dateFormat = extraConfigParam?.DATE_FORMAT;
  const TIME_FORMAT = extraConfigParam?.TIME_FORMAT_MERIDIEM || false;
  


  const [therapistPreferenceData, setTherapistPreferenceData] = useState([
    { key: "NO_PREFERENCE", value: "No Preference" },
    { key: "MALE", value: "Male" },
    { key: "FEMALE", value: "Female" },
  ]);
  const [therapistPreference, setTherapistPreference] = useState("NO_PREFERENCE");

  const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [inputDateFormat, setInputDateFormat] = useState("");


  const [eta, setETA] = useState("");
  const [etaTimeList, setETATimeList] = useState([]);



  const handleDateChange = (selectedDate) => {
    if (!selectedDate) {
      setSelectedDate("");
      setInputDateFormat("");
    } else {
      const formattedDate = moment(selectedDate, 'YYYY/MM/DD').format('YYYY-MM-DD');

      setSelectedDate(formattedDate);
      setInputDateFormat(
        dateFormatHandler(
          new Date(formattedDate).toISOString(),
          dateFormat
        )
      );

      setIsDatePickerVisible(false);
    }
  }

  const editSelectedAddon=(addon)=>{
    let selectedAddons = JSON.parse(JSON.stringify(bookingObj?.selectedAddon));

    if(selectedAddons.some(addon_=>addon_.id == addon.id)){
      selectedAddons =  selectedAddons.filter(addon_=> addon_.id != addon.id);
    }else{
      selectedAddons.push(addon)
    } 
    
    updateBookingObj({selectedAddon: selectedAddons})
  }

  const generateTimeOptions = () => {
    const options = [];
    for (let hours = 0; hours < 24; hours++) {
      for (let minutes = 0; minutes < 60; minutes += 30) {
        const hourString = String(hours).padStart(2, "0");
        const minuteString = String(minutes).padStart(2, "0");
        const timeValue = `${hourString}:${minuteString}`;
        const formatedTimeValue = timeValue;
        options.push(formatedTimeValue);
      }
    }
    setETATimeList(options);
  };

  const handleGoNext = () => {
    if (selectedDate == "") {
      dispatch(setRenderFlashMessage(true, {type: "danger", message: t("spaBooking.select_preferred_date")}))
      return;
    }

    let serviceDetailsPayload;

    if (eta) {
      serviceDetailsPayload = {
        dateTime: `${selectedDate}T${eta}:00`,
        requestedType: therapistPreference,
      };
    } else {
      serviceDetailsPayload = {
        dateTime: `${selectedDate}`,
        requestedType: therapistPreference,
      };
    }

    handleNext(serviceDetailsPayload);
  }

  const getCheckoutDate = ()=>{
        if(!currentGuestDetails) return undefined;
        return currentGuestDetails && currentGuestDetails.plannedCheckOutDate ? new Date(currentGuestDetails.plannedCheckOutDate.replace('Z',"")) : undefined
  }

  const checkoutDate = getCheckoutDate();

  useEffect(() => {
    if (!bookingObj?.spaLocationId || !bookingObj?.selectedService) {
      updateFetchApiError(true, t("spaBooking.errors.no_data_found"))
      handleGoBack();

      return;
    }

    generateTimeOptions();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  

  return (
    <View style={getStyles(['widgetRootContainer', 'spaBookingRootContainer'])} id='spaBookingRootContainer'>
      <HeaderWithBack handleCustomBackPress={handleGoBack} />

      <ScrollView
        automaticallyAdjustKeyboardInsets={true} 
        contentContainerStyle={getStyles(['widgetmainContainer', 'spaBookingMainContainer'])} 
        showsVerticalScrollIndicator={false}
        id='spaBookingMainContainer'
      >
        <View style={getStyles(['widgetmainContainerHeaderContainer', 'spaBookingHeaderContainer'])} id='spaBookingHeaderContainer'>
          {
            currentWidget?.widgetHeaderImageUrl && 
              <ImageComp
                source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} 
                style={getStyles(['widgetmainContainerHeaderImg', 'spaBookingHeaderImg'])} id={"spaBookingHeaderImg"}
              />
          }
          <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'spaBookingHeaderTitleContainer'])} id='spaBookingHeaderTitleContainer'>
            <ImageComp source={HEART} style={getStyles(["spaBookingHeaderTitleImage"])} id="spaBookingHeaderTitleImage"/>

            <Text style={getStyles(['widgetmainContainerHeaderTitle', 'spaBookingHeaderTitle'])} id='spaBookingHeaderTitle'>
              {t("spaBooking.add_ons.heading")}
            </Text>
            <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'spaBookingHeaderSubTitle'])} id='spaBookingHeaderSubTitle'>
              {t("spaBooking.add_ons.subheading")}
            </Text>

            <View style={getStyles(["horizontalline"])} id='horizontalline'></View>
          </View>
        </View>


        <View style={getStyles(['widgetmainContainerChildContainer', 'spaBookingMainContainerChildContainer'])} id='spaBookingMainContainerChildContainer'>
          <View style={getStyles(["spaBookingTopContainer"])} id='spaBookingTopContainer'>
            <View style={getStyles(["spaBookingDurationContainer"])} id='spaBookingDurationContainer'>
              <Text style={getStyles(["spaBookingDurationTtitleText"])} id='spaBookingDurationTtitleText'>{t("spaBooking.duration")}</Text>
              <Text style={getStyles(["spaBookingDurationText"])} id='spaBookingDurationText'>{bookingObj?.selectedService.service.duration} min</Text>
            </View>

            <View style={getStyles(["spaBookingBaseContainer"])} id='spaBookingBaseContainer'>
              <Text style={getStyles(["spaBookingBasePriceTitleText"])} id='spaBookingBasePriceTitleText'>{t("spaBooking.base_price")}</Text>
              <Text style={getStyles(["spaBookingBasePriceText"])} id='spaBookingBasePriceText'>
                {`${currencyCode} ${bookingObj?.selectedService.service.price}`}
                <Text style={getStyles(["spaBookingBasePriceText2"])} id='spaBookingBasePriceText2'>{t("spaBooking.per_person")}</Text>
              </Text>
            </View>
          </View>

          <View style={getStyles(["spaBookingAddOnListMainContainer"])} id='spaBookingAddOnListMainContainer'>
            {bookingObj?.availableAddOns &&  Array.isArray(bookingObj?.availableAddOns) && bookingObj?.availableAddOns.length > 0 && 
              <View style={getStyles(["spaBookingAddOnListContainer"])} id='spaBookingAddOnListContainer'>
                <Text style={getStyles(["spaBookingAddOnListHeading"])} id='spaBookingAddOnListHeading'>{t("spaBooking.enhancements")}</Text>

                <Text style={getStyles(["spaBookingAddOnListSubHeading"])} id='spaBookingAddOnListSubHeading'>{t("spaBooking.enhancements_subheading")}</Text>

                <View style={getStyles(["spaBookingAddOnListAddonsContainer"])} id='spaBookingAddOnListAddonsContainer'>
                  {bookingObj?.availableAddOns.map((option) => (
                    <CustomPressable 
                      style={getStyles(["list_itemContainer", "spaBookingAddOnListItemAddonsContainer"])} 
                      id='spaBookingAddOnListItemAddonsContainer' 
                      key={option.id}
                      onPress={() => editSelectedAddon(option)}
                    >
                      <CustomCheckBoxWithProps
                        checkBoxStyle={getStyles(["spaBooking1aOnlineListItemCheckbox"])}
                        value={bookingObj?.selectedAddon.some(addon=> addon.id == option.id)}
                        onValueChange={() => {}}
                        id="spaBooking1aOnlineListItemCheckbox"
                      />
                      
                      <Text style={getStyles(["spaBookingAddOnListItemAddonsContainerName"])} id='spaBookingAddOnListItemAddonsContainerName'>
                        {option.name}
                      </Text>
                      <Text style={getStyles(["spaBookingAddOnListItemAddonsContainerPrice"])} id='spaBookingAddOnListItemAddonsContainerPrice'>
                        {`${currencyCode} ${option.price}`}
                      </Text>
                    </CustomPressable>
                  ))}
                </View>
            </View>}
            
            <View style={getStyles(["spaBooking2aTherapistContainer"])} id='spaBooking2aTherapistContainer'>
              <Text style={getStyles(["spaBooking2aTherapistContainerTitle"])} id='spaBooking2aTherapistContainerTitle'>
                {t("spaBooking.therapist")}
              </Text>

              {therapistPreferenceData.map((option) => (
                <CustomPressable style={getStyles(["list_itemContainer", "spaBooking2aTherapistItem"])} id='spaBooking2aTherapistItem' key={option.key} onPress={()=> setTherapistPreference(option.key)}>
                  <CustomCheckBoxWithProps
                    checkBoxStyle={getStyles(["spaBooking1aOnlineListItemCheckbox"])}
                    value={therapistPreference === option.key}
                    id="spaBooking1aOnlineListItemCheckbox"
                    onValueChange={() => {}}
                  />
                  <Text style={getStyles(["spaBookingAddOnListItemAddonsContainerName"])} id='spaBookingAddOnListItemAddonsContainerName'>{option.value}</Text>
                </CustomPressable>
              ))}
            </View>

            <View style={getStyles(['textContainer', "spaBookingDateContainer"])} id='textContainer spaBookingDateContainer'>
              <Text style={getStyles(['label', 'spaBookingDataContainerLabel'])} id='spaBookingDataContainerLabel'>
                {bookingObj?.updateReservationDetails ? t("spaBooking.selected_date") : t("spaBooking.preferred_date")}
                <Text style={{ color: "red" }}>*</Text>
              </Text>

              <CustomPressable onPress={() => setIsDatePickerVisible(true)}>
                <CustomTextInput
                  value={dateFormat != null ? inputDateFormat || t("spaBooking.select_date_placeholder") : selectedDate || t("spaBooking.select_date_placeholder")}
                  placeholder={t("spaBooking.selected_date_placeholder")}
                  editable={false}
                  pointerEvents="none"
                />
              </CustomPressable>
            </View>

            <View style={getStyles(['dropdownContainer', "spaBookingDropdownContainer"])} id='dropdownContainer spaBookingDropdownContainer'>
              <CustomDropDown 
                label={t("spaBooking.preferred_time")}
                options={etaTimeList?.map((time, index) => ({
                    value: time,
                    label: formatEstimateCheckInTime(time, toBool(TIME_FORMAT))
                }))}
                selectedOption={eta.key}
                onSelectOption={(e)=> {
                  setETA(e);
                }}
              />
            </View>
          </View>

        </View>
      </ScrollView>

      <View id='spaBookingNextButtonContainer' style={getStyles(['spaBookingNextButtonContainer'])}>
        <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleGoNext} id="primaryBtn" disabled={selectedDate == ""}>
          <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>
            {t("spaBooking.next")}
          </Text>
        </CustomPressable>

        <CustomPressable style={getStyles(['secondaryBtn'])} onPress={handleGoBack}>
          <Text style={getStyles(['secondaryBtnTxt'])}>{t('spaBooking.back')}</Text>
        </CustomPressable>
      </View>

      {isDatePickerVisible &&
        <DatePickerModal
          selectedDate={selectedDate}
          onDateChange={handleDateChange}
          onClose={() => setIsDatePickerVisible(false)}
        />
      }
      
    </View>
  )
}


const formatEstimateCheckInTime = (time, timeFormat12hrs) => {
  if (!time) {
    return "";
  }

  const [hours, minutes] = time.split(":");

  if (timeFormat12hrs) {
    let period = "AM";
    let hour = parseInt(hours, 10);

    if (hour >= 12) {
      period = "PM";
      if (hour > 12) {
        hour -= 12;
      }
    }

    return `${hour}:${minutes} ${period}`;
  } else {
    return `${hours}:${minutes}`;
  }
};

export default SpaBooking2a
